import React from "react";

import {Shell} from "@client/components/Shell";

export function Template() {
    return (
        <Shell>
            <h1 className="mb-4 text-2xl font-bold">Predictions</h1>
            <div>Ok</div>
        </Shell>
    );
}
